module.exports = __webpack_public_path__ + "static/media/story_flipCards.b6899ba1.png";